import { Theme } from "@mui/material/styles"

export const formatTime = (seconds: number, fps: number): string => {
    const h = Math.floor(seconds / 3600)
    const m = Math.floor((seconds % 3600) / 60)
    const s = Math.floor(seconds % 60)
    const last = Math.floor((seconds % 1) * (fps === 1 ? 100 : fps))

    const pad = (n: number, z = 2) => String(n).padStart(z, "0")
    const lastPad = 2 //two decimal number for fps 25 | fps 50 | fps 1 = ss 99

    return `${h}:${pad(m)}:${pad(s)}:${String(last).padStart(lastPad, "0")}`
}

export const parseTime = (timeStr: string, fps: number): number => {
    const parts = timeStr.split(":").map(Number)
    if (parts.length !== 4 || parts.some(isNaN)) return NaN

    const [h, m, s, f] = parts
    return h * 3600 + m * 60 + s + (fps === 1 ? f / 100 : f / fps)
}

export const validateTimeString = (str: string, fps: number): boolean => {
    const parts = str.split(":").map(Number)
    if (parts.length !== 4 || parts.some(isNaN)) return false

    const [h, m, s, f] = parts
    const isValidTime = h < 24 && m < 60 && s < 60
    if (!isValidTime) return false

    return fps === 1 ? f < 100 : f < fps
}

export const buildIntroOutroBackground = (
    width: number,
    baseColor: string,
    introEnd: number | null,
    outroStart: number | null,
    effectiveDuration: number,
    timeStepFromTime: number,
    timeStepToTime: number,
    theme: Theme
): string => {
    const introOutroColor = theme.palette.grey[600]
    if (!introEnd && !outroStart) return baseColor

    const showIntroBand = !!introEnd && timeStepFromTime < introEnd
    const showOutroBand =
        !!outroStart && timeStepToTime > outroStart && timeStepFromTime < effectiveDuration

    if (!showIntroBand && !showOutroBand) return baseColor

    const clampPx = (time: number) =>
        Math.min(width, Math.max(0, (width * (time - timeStepFromTime)) / 1))

    let background = `linear-gradient(to right, ${baseColor} 0px,`

    if (showIntroBand && introEnd) {
        const introEndPx = clampPx(introEnd)
        background += `${baseColor} 0px,${introOutroColor} 0px,${introOutroColor} ${introEndPx}px,${baseColor} ${introEndPx}px,`
    }

    if (showOutroBand && outroStart) {
        const outroEnd = Math.min(effectiveDuration, timeStepToTime)
        const outroStartPx = clampPx(outroStart)
        const outroEndPx = clampPx(outroEnd)
        background += `${baseColor} ${outroStartPx}px,${introOutroColor} ${outroStartPx}px,${introOutroColor} ${outroEndPx}px,${baseColor} ${outroEndPx}px,`
    }

    background += `${baseColor} ${width}px)`
    return background
}
